import './ideya-button.scss'
import Button, { ButtonProps } from 'antd/es/button'
import { useAppSelector } from '../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../features/setting/setting.slice.ts'

type IdeyaButtonProps = ButtonProps & {
  ideyaType?: 'secondary' | 'antd' | 'bw' | ''
}

export const IdeyaButton: React.FC<IdeyaButtonProps> = ({
  ideyaType,
  style,
  ...rest
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  let customStyle = style
  let className = rest.className || ''

  switch (ideyaType) {
    case 'secondary':
      className += ' btn-secondary'
      customStyle = {
        backgroundColor: themeStyle.btnBgRound,
        color: themeStyle.colorBWText,
        borderColor: themeStyle.colorBorder,
        ...style,
      }
      break
    case 'antd':
      customStyle = {
        backgroundColor: themeStyle.btnBgRound,
        color: themeStyle.colorText,
        border: `1px solid ${themeStyle.defaultBorderColor}`,
        ...style,
      }
      break
    case 'bw':
      className += ' btn-bw'
      customStyle = {
        backgroundColor: themeStyle.btnBgRound,
        color: themeStyle.colorBWText,
        border: `1px solid ${themeStyle.defaultBorderColor}`,
        borderRadius: themeStyle.borderRadiusBase,
        boxShadow: `0 2px 0 var(--ant-control-tmp-outline)`,
        ...style,
      }
      break
    default:
      customStyle = style
  }

  return <Button className={className} style={customStyle} {...rest} />
}
